/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'

import * as Icons from './index'

/* istanbul ignore next */
const Icon = ({ name, ...props }) => {
  const Component = Icons[name] // eslint-disable-line import/namespace
  if (!Component) return false
  return <Component {...props} />
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
}

Icon.defaultProps = {
  color: 'inherit',
}

Icon.displayName = 'Icon'

export default Icon
